import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { ProjectElementType } from "@planzone/dto";
import { useModal } from "@root/client/modal";
import { SecureContextualMenu } from "@common/secureContextualMenu";
import { clip } from "@common/clipeable";
import { Props } from "./types";
import styles from "./styles.scss";

function Timestamp({ milestone, project }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <div className={styles.timestamp}>
      <div className={styles.contextualMenu}>
        <SecureContextualMenu
          context={{ milestone }}
          items={[
            {
              name: t("milestoneRetrieval.copyUrl"),
              useCase: UseCases.retrieveMilestone,
              act: () =>
                clip(`${location.origin}/milestones/${milestone.uuid}`, null),
            },
            {
              name: t("milestoneRetrieval.move"),
              useCase: UseCases.moveListElement,
              act: () =>
                pushView({
                  key: UseCases.moveListElement,
                  data: {
                    projectElementId: milestone.uuid,
                    projectElementType: ProjectElementType.MILESTONE,
                    currentParentList: milestone.list,
                    project,
                  },
                }),
            },
            {
              name: t("milestoneRetrieval.remove"),
              useCase: UseCases.removeMilestone,
              act: () =>
                pushView({ key: UseCases.removeMilestone, data: milestone }),
            },
          ]}
        />
      </div>
    </div>
  );
}

export { Timestamp };
